import { useLocation } from "react-router-dom";
import { pickBy, isEmpty } from "lodash-es";
import { Params } from "@/facilities/model/user";

export const useUrlPath = () => {
  const { pathname, search, hash } = useLocation();

  const getUrlParams = (values?: Params) => {
    if (isEmpty(values)) {
      return pathname;
    }
    const path = new URLSearchParams(
      pickBy(values as Record<string, string>)
    ).toString();
    if (hash) {
      return `${pathname}${hash}${hash.includes("?") ? "&" : "?"}${path}`;
    }
    if (search) {
      return `${pathname}${search}&${path}`;
    }
    return `${pathname}?${path}`;
  };

  const fttomrUrl = (url: URL) => {
    const upHash = url.hash;
    const upSearch = url.search;
    if (upHash && upSearch) {
      return `${pathname}${upHash}${
        upHash.includes("?") ? `&${upSearch.split("?")[1]}` : upSearch
      }`;
    }
    return `${pathname}${upHash}${upSearch}`;
  };

  const updateNameToUrl = (key: string, name: string) => {
    const url = new URL(decodeURIComponent(window.location.href));
    url.searchParams.set(key, name);
    return fttomrUrl(url);
  };

  const deleteNameToUrl = (key: string) => {
    const url = new URL(decodeURIComponent(window.location.href));
    url.searchParams.delete(key);
    return fttomrUrl(url);
  };

  return {
    deleteNameToUrl,
    updateNameToUrl,
    getUrlParams,
  };
};

export default useUrlPath;
